import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { MistakeMode, Theme } from '../api/types';
import { useSettings } from '../settings/SettingsContext';

const THEMES: Theme[] = ['system', 'light', 'dark'];
const MISTAKE_MODES: { value: MistakeMode; label: string }[] = [
  { value: 'off', label: 'Off' },
  { value: 'highlight', label: 'Highlight conflicts' },
  { value: 'strike', label: 'Strike limit (3)' },
];

export function Settings() {
  const { settings, update } = useSettings();
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    api<{ version: string }>('/version')
      .then((v) => setVersion(v.version))
      .catch(() => {
        /* best-effort — leave version hidden */
      });
  }, []);

  return (
    <section className="settings">
      <h1>Settings</h1>

      <label className="row">
        <span>Theme</span>
        <select value={settings.theme} onChange={(e) => update({ theme: e.target.value as Theme })}>
          {THEMES.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </label>

      <label className="row">
        <span>Mistake handling</span>
        <select
          value={settings.mistake_mode}
          onChange={(e) => update({ mistake_mode: e.target.value as MistakeMode })}
        >
          {MISTAKE_MODES.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </label>

      <Toggle
        label="Auto-remove notes on placement"
        checked={settings.auto_remove_notes}
        onChange={(v) => update({ auto_remove_notes: v })}
      />
      <Toggle
        label="Highlight peer cells"
        checked={settings.highlight_peers}
        onChange={(v) => update({ highlight_peers: v })}
      />
      <Toggle
        label="Highlight same number"
        checked={settings.highlight_same_number}
        onChange={(v) => update({ highlight_same_number: v })}
      />
      <Toggle
        label="Hints enabled"
        checked={settings.hints_enabled}
        onChange={(v) => update({ hints_enabled: v })}
      />

      {version && <p className="settings-version">Version {version}</p>}
    </section>
  );
}

function Toggle({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label className="row toggle">
      <span>{label}</span>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
    </label>
  );
}
